export const capitalizeFirstLetter = (
  string?: string | null,
  lowercaseRest = false,
): string => {
  if (!string || typeof string !== 'string' || string.length === 0) {
    return ''; // return empty string if string is not provided, is null, or is an empty string
  }

  const firstLetter = string.charAt(0).toUpperCase();

  const restOfString = lowercaseRest
    ? string.slice(1).toLowerCase()
    : string.slice(1);

  return firstLetter + restOfString;
};
